function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createConsumer } from '@rails/actioncable';
import { received } from '../reflexes';
import { emitEvent } from '../utils';
var consumer;
var params;
var subscriptionActive;

var createSubscription = function createSubscription(controller) {
  consumer = consumer || controller.application.consumer || createConsumer();
  var channel = controller.StimulusReflex.channel;

  var subscription = _objectSpread({
    channel: channel
  }, params);

  var identifier = JSON.stringify(subscription);
  controller.StimulusReflex.subscription = consumer.subscriptions.findAll(identifier)[0] || consumer.subscriptions.create(subscription, {
    received: received,
    connected: connected,
    rejected: rejected,
    disconnected: disconnected
  });
};

var connected = function connected() {
  subscriptionActive = true;
  document.body.classList.replace('stimulus-reflex-disconnected', 'stimulus-reflex-connected');
  emitEvent('stimulus-reflex:connected');
  emitEvent('stimulus-reflex:action-cable:connected');
};

var rejected = function rejected() {
  subscriptionActive = false;
  document.body.classList.replace('stimulus-reflex-connected', 'stimulus-reflex-disconnected');
  emitEvent('stimulus-reflex:rejected');
  emitEvent('stimulus-reflex:action-cable:rejected');
  if (Debug.enabled) console.warn('Channel subscription was rejected.');
};

var disconnected = function disconnected(willAttemptReconnect) {
  subscriptionActive = false;
  document.body.classList.replace('stimulus-reflex-connected', 'stimulus-reflex-disconnected');
  emitEvent('stimulus-reflex:disconnected', willAttemptReconnect);
  emitEvent('stimulus-reflex:action-cable:disconnected', willAttemptReconnect);
};

export default {
  consumer: consumer,
  params: params,

  get subscriptionActive() {
    return subscriptionActive;
  },

  createSubscription: createSubscription,
  connected: connected,
  rejected: rejected,
  disconnected: disconnected,
  set: function set(consumerValue, paramsValue) {
    consumer = consumerValue;
    params = paramsValue;
  }
};